var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTableIconActionUnpaid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 4.27L4.28 3L21 19.72L19.73 21L16.06 17.33C15.44 18 14.54 18.55 13.5 18.82V21H10.5V18.82C8.47 18.31 7 16.79 7 15H9C9 16.08 10.37 17 12 17C13.13 17 14.14 16.56 14.65 15.92L11.68 12.95C9.58 12.42 7 11.75 7 9C7 8.77 7 8.55 7.07 8.34L3 4.27ZM10.5 5.18V3H13.5V5.18C15.53 5.69 17 7.21 17 9H15C15 7.92 13.63 7 12 7C11.63 7 11.28 7.05 10.95 7.13L9.4 5.58L10.5 5.18Z",
    fill: "#627686"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableIconActionUnpaid);
export default __webpack_public_path__ + "static/media/table_icon_action_unpaid.064cb36ae28f94605606639b9bd5b768.svg";
export { ForwardRef as ReactComponent };